import React from "react";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import IntlMessages from "helpers/IntlMessages";
import { persistor } from "../../redux/store";
import { getLogOut } from "../../redux/user/AuthenSlice";
import { useDispatch } from "react-redux";

function AlertToken(props) {
  const dispatch = useDispatch();

  function closeAlert() {
    const status = "true";

    dispatch(getLogOut());
    persistor.purge();
    props.close(status);
  }

  return (
    <>
      <Modal show={props.show} centered>
        <Modal.Body>
          <div className="alert-headsession">
            <IntlMessages id="user.session" />
          </div>
          <div className="delete-detail mb-3 alert-session">
            <IntlMessages id="user.please-lognin" />
          </div>
        </Modal.Body>

        <Modal.Footer>
          <div className="btn-submit">
            <Button type="submit" className="btn-save" onClick={closeAlert}>
              <IntlMessages id="button.ok" />
            </Button>
          </div>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default AlertToken;
